import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const WaiterService = {
  // Define your API functions here
  authRole: async () => {
    const response = await apiService.get("/auth/roles");
    return response.data;
  },
  create: async (data) => {
    try {
      const response = await apiService.post("/organizationuser", data);
      return response.data;
    } catch (error) {
      console.error("Error creating tenant:", error);
      throw error;
    }
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(
        `/organizationuser/${id}`,
        updatedData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  getList: async () => {
    const response = await apiService.get("/organizationuser");
    return response.data;
  },
  getCustomerDetail: async (id) => {
    const response = await apiService.get(`/organizationuser/${id}`);
    return response.data;
  },
  getCustomerBooking: async (id) => {
    const response = await apiService.get(`/customers/${id}/bookings`);
    return response.data;
  },

  guestUserList: async () => {
    const response = await apiService.get("/guestusers");
    return response.data;
  },
  getGuestDetail: async (id) => {
    const response = await apiService.get(
      `/organizationuser/guest/withorderdetail/${id}`
    );
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/organizationuser/${id}`);
    return response.data;
  },
};

export default WaiterService;
